import { useTranslation } from "react-i18next";
import SearchInput from "../search-input";
import { useSubmissionsFilterStore } from "@/features/dilemmas/stores";
import SubmissionsFilterComponent from "@/features/dilemmas/components/submissions-filter-component";

const SubmissionPageHeader = () => {
  const { t } = useTranslation();
  const { searchValue, setSearchValue } = useSubmissionsFilterStore();
  return (
    <div className="flex-1 flex items-center justify-between gap-4 w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.submissions")}</h1>
      <div className="flex items-center gap-2 flex-1 justify-end">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          className="max-w-72 hidden lg:flex"
        />
        <div className="hidden lg:block">
          <SubmissionsFilterComponent />
        </div>
      </div>
    </div>
  );
};

export default SubmissionPageHeader;
